<template>
  <v-expansion-panel
    v-if="!isNew"
    @click="handleExpand"
  >
    <v-expansion-panel-header>{{ $t('booking.limitFieldsTime.title', locale)}} [byWorkspace]</v-expansion-panel-header>
    <v-expansion-panel-content
      class="form-fields-list-main"
    >
      <v-layout wrap>
        <v-flex xs12 style="padding: 20px 20px 10px 20px">
          <small style="color: red; font-size:12px;line-height:1px;">NOTA: afecta a <b>todas</b> las actividades del gestor, si reservas en la act1 no puedes reservar en la act2, act3, etc.</small>
          <v-autocomplete
            v-if="formFields"
            v-model="selectedFields"
            :items="formFields"
            outlined
            chips
            itemText="name"
            itemValue="id"
            small-chips
            label="campos"
            multiple
            hide-details
            @change="handleChange"
            style="margin-top:20px;"
          />
        </v-flex>
        <v-flex 
          v-if="selectedFields && selectedFields.length > 1"
          xs12 
          style="padding: 10px 20px 10px 20px"
        >
          <v-select
            :items="modes"
            v-model="selectedMode"
            itemText="name"
            itemValue="id"
            label="Modo"
            hide-details
            outlined
            @change="handleChange"
          />
        </v-flex>
        <v-flex xs6 style="padding: 10px 10px 20px 20px">
          <custom-text-field-number
            v-model="timeLimit"
            label="Tiempo"
            @input="handleChange"
          />
        </v-flex>
        <v-flex xs6 style="padding: 10px 20px 20px 10px">
          <v-select
            v-model="selectedTimeType"
            :items="[{
                id: 'days',
                name:  $t('booking.activities.days', locale),
              },
              {
                id: 'minutes',
                name:  $t('booking.activities.minutes', locale),
              },
            ]"
            itemText="name"
            itemValue="id"
            outlined
            hide-details
            @change="handleChange"
          />
        </v-flex>
      </v-layout>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
import api from '@/services/api'
import utils from '@/services/utils'
import CustomTextFieldNumber from '@/components/CustomTextFieldNumber'
export default {
  components: {
    CustomTextFieldNumber,
  },
  props: {
    locale: {
      type: String,
      default: null,
    },
    onChangeData: {
      type: Function,
      required: true,
    },
    allowReservations: {
      type: Boolean,
      default: false,
    },
    workspaceID: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    formFields: null,
    selectedFields: null,
    modes: [
      {
        id: 'and',
        name: 'and',
      },
      {
        id: 'or',
        name: 'or'
      }
    ],
    selectedMode: 'and',
    timeLimit: 0,
    selectedTimeType: 'days'
  }),
  computed: {
    isNew () {
      return this.workspaceID === 'new'
    },
  },
  methods: {
    handleExpand () {
      if (this.workspaceID) this.handleGetData()
    },
    handleGetData () {
      //api.getAllWithoutLimit ('booking', `v1/private/activities/${this.editedActivityID}/limit-fields-time`)
      api.getAllWithoutLimit ('booking', `v1/private/workspaces/${this.workspaceID}/limit-fields-time`)
        .then(response => {
          let aux = response//.shift()
          if (aux) {
            if (aux.Data && aux.Data.length > 0) aux = JSON.parse(aux.Data)
            if (aux.fields) this.selectedFields = aux.fields
            if (aux.mode) this.selectedMode = aux.mode
            if (aux.timeLimit) this.timeLimit = aux.timeLimit
            if (aux.timeType) this.selectedTimeType = aux.timeType
          }
          this.handleGetFields()
        })
    },
    handleGetFields () {
      this.loading = true
      api.getAllWithoutLimit('booking', 'v1/internal/constants/owner-form-fields')
        .then (response => {
          this.formFields = response.ownerFormFields.map(item => {
            return {
              id: item.key,
              name: utils.getTranslation(item.label, this.locale)
            }
          })
        })
    },
    handleChange () {
      this.onChangeData({
        fields: this.selectedFields,
        mode: this.selectedMode,
        timeLimit: this.timeLimit,
        timeType: this.selectedTimeType,
      })
    },
  },
}
</script>

